import { createContext } from 'react';

const initialSideNavContext = {
  isClosed: false,
  isCompact: false,
  isMobile: false,
  isScrolling: false,
  toggleClosed: () => {},
  setScrolling: () => {},
};

export type SideNavContextType = {
  /** SideNav open and closed state  */
  isClosed: boolean;
  /** If SideNav should float above content  */
  isCompact: boolean;
  /** SideNav mobile state, hidden when closed, full width when open */
  isMobile?: boolean;
  isScrolling: boolean;
  toggleClosed: () => void;
  setScrolling: (scrolling: boolean) => void;
};

export const SideNavContext = createContext<SideNavContextType>(initialSideNavContext);
